export default function valuesQuery(keyQuery) {
    const query = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, props) => searchParams.get(props),
    });
    return query[keyQuery];
}
